import React from "react";
import LegalPageLayout from "./LegalPageLayout";
import C from "./legal.config";

/**
 * /legal/contact-info — Canadian operator disclosure.
 *
 * Equivalent to the German "Impressum" but written for PIPEDA +
 * provincial consumer-protection norms. Lists the legal entity behind
 * the site so users (and regulators) can identify who's accountable.
 */
export default function ContactInfo() {
  return (
    <LegalPageLayout title="Legal / Operator Information">
      <p>
        This page identifies the operator of LEAGUE HUB and provides
        the contact details required under Canadian consumer-protection
        and electronic-commerce rules.
      </p>

      <h2 className="legal-h2">Operator</h2>
      <p>
        <strong>{C.legal_entity_name}</strong>
        <br />
        {C.legal_address}
        <br />
        Province of {C.province}, {C.country}
      </p>

      <h2 className="legal-h2">Contact</h2>
      <p>
        General: <a href={`mailto:${C.contact_email}`}>{C.contact_email}</a><br />
        Privacy / data requests: <a href={`mailto:${C.privacy_email}`}>{C.privacy_email}</a><br />
        Abuse / safety: <a href={`mailto:${C.abuse_email}`}>{C.abuse_email}</a>
      </p>

      <h2 className="legal-h2">Tax registration</h2>
      <p>
        {C.gst_hst_number
          ? <>GST/HST number: <code>{C.gst_hst_number}</code></>
          : "GST/HST number: not yet registered. We will display the number here once registered with the Canada Revenue Agency."}
      </p>

      <h2 className="legal-h2">Online dispute resolution</h2>
      <p>
        Consumers in Canada may contact the applicable provincial
        consumer-protection office (e.g. Consumer Protection Ontario)
        if a dispute cannot be resolved by writing to us first. EU
        consumers may use the European Commission's Online Dispute
        Resolution platform at{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
          ec.europa.eu/consumers/odr
        </a>; we are not obligated to participate but we will engage in
        good faith.
      </p>

      <h2 className="legal-h2">Responsible for content</h2>
      <p>
        {C.legal_entity_name} is responsible for the editorial content
        of LEAGUE HUB. User-generated content (DMs, league chat,
        uploads, badges, league branding) is the responsibility of the
        respective user. See our{" "}
        <a href="/legal/community" className="underline">Community Guidelines</a>{" "}
        for how we moderate UGC.
      </p>

      <p className="text-white/45 text-xs">
        Last updated: {C.last_updated}.
      </p>
    </LegalPageLayout>
  );
}
